﻿import { Coordinate } from "ol/coordinate";
import { ProjectionLike } from "ol/proj";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";

import { BaseGeometryExtension } from "./BaseGeometryExtension";
import GeodesicCircle from "../custom/GeodesicCircle"

import { Coordinates } from "../models/Coordinates";
import { Projections } from "../../models/Projections";

export class GeodesicCircleExtension extends BaseGeometryExtension<GeodesicCircle> {

    public getCoordinates(): Coordinates {
        return this.geometry.getCenter()
    }

    public setCoordinates(coordinates: Coordinate): void {
        this.geometry.setCenter(coordinates);
    }

    public intersectsExtent(extent: [number, number, number, number]) {
        return this.geometry.intersectsExtent(extent);
    }

    public getRadius(projection: ProjectionLike = Projections.WebMercator) {
        return this.geometry.getRadius(projection);
    }

    public setRadius(radius: number, projection: ProjectionLike = Projections.WebMercator) {
        this.geometry.setRadius(radius, projection);
    }

    public getClosestCoordinates(point: Coordinate) {
        return this.geometry.getCenter()
    }

    public insertGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        return undefined;
    }

    public replaceGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        if (geometry instanceof GeodesicCircle) {
            this.setCoordinates(geometry.getCenter().slice())
            return [];
        }
        else if (geometry instanceof Point) {
            this.setCoordinates(geometry.getCoordinates().slice())
            return [];
        }
        return undefined
    }

    public removeGeometry(path: number[]): number[] | undefined {
        return undefined;
    }

    public canRemove(path: number[]): boolean {
        return false;
    }

    public groupSectionsAtDateLine() {
    }

    public mergeSnappedPoints() {               
        return false;
    }
}